import React from 'react';
import './App.css';
import plato from './images/icons/logo2.png';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <footer className='footer'>
      
      <div className='footer-section logo-sec'>
        <img src={plato} alt="Plato Logo" />
      </div>

      <div className='footer-section'>
        <Link className='f' to="/"><p><a href=''>Home</a></p></Link>
      </div>

      <div className='footer-section'>
        <Link className='f' to="/about"><p><a href=''>About</a></p></Link>
        <div className='p'>
          <Link to="/about#our-story">Our Story</Link><br />
          <Link to="/about#our-works">Our Works</Link><br />
          <Link to="/about#how-it-works">How It Works</Link><br />
          <Link to="/about#our-team">Our Team</Link><br />
          <Link to="/about#our-clients">Our Clients</Link>
        </div>
      </div>

      <div className='footer-section'>
        <Link className='f' to="/menu"><p><a href=''>Menu</a></p></Link>
        <div className='p'>
          <Link to="/menu#portfolio">Todays special</Link><br />
          <Link to="/menu#categories">Categories</Link>
        </div>
      </div>

      <div className='footer-section'>
        <Link className='f' to="/book-a-table"><p><a href=''>Book A Table</a></p></Link>
        <div className='p'>
          <Link to="/Booktable#valuation">Valuation Mastery</Link><br />
          <Link to="/Booktable#marketing">Strategic Marketing</Link><br />
          <Link to="/Booktable#negotiation">Negotiation Wizardry</Link><br />
          <Link to="/Booktable#closing">Closing Success</Link><br />
          <Link to="/Booktable#management">Property Management</Link>
        </div>
      </div>

      <div className='footer-section'>
        <Link className='f' to="/contact"><p className='f'><a href=''> Contact</a></p></Link>
        <div className='p'>
          <Link to="/contact#contact-form">Contact Form</Link><br />
          <Link to="/contact#offices">Our Offices</Link>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
